var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerSuitcaseRolling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-suitcase-rolling",
    "data-name": "Icon awesome-suitcase-rolling",
    d: "M10.5,5h-9A1.5,1.5,0,0,0,0,6.5v7A1.5,1.5,0,0,0,1.5,15H2v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V15H8v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V15h.5A1.5,1.5,0,0,0,12,13.5v-7A1.5,1.5,0,0,0,10.5,5ZM10,11.75a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,11.75v-.5A.25.25,0,0,1,2.25,11h7.5a.25.25,0,0,1,.25.25Zm0-3A.25.25,0,0,1,9.75,9H2.25A.25.25,0,0,1,2,8.75v-.5A.25.25,0,0,1,2.25,8h7.5a.25.25,0,0,1,.25.25ZM4.5,1.5h3V4H9V1.5A1.5,1.5,0,0,0,7.5,0h-3A1.5,1.5,0,0,0,3,1.5V4H4.5Z",
    fill: "#16d696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSuitcaseRolling);
export default __webpack_public_path__ + "static/media/banner-suitcase-rolling.0359ebb4724602e1865d7fcd6f209bef.svg";
export { ForwardRef as ReactComponent };